




































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import CanBeSizedMixin from '@/mixins/CanBeSizedMixin.vue';
import { IdealoShopModel } from '@/models/Idealo';
import ScrollableMixin from '@/mixins/ScrollableMixin.vue';
import { mixins } from 'vue-class-component';

@Component({})
export default class IdealoDetails extends mixins(CanBeSizedMixin, ScrollableMixin) {
  /* tslint:disable */
  @Prop() private offer!: IdealoShopModel;
  @Prop({ default: 0 }) private height!: number;
  /* tslint:enable */

  @Watch('offer', { deep: true })
  public refresh() {
    console.log('refreshing');
    (this.$refs as any).vs.refresh();
  }

  private get heightStyle() {
    if (!this.small) {
      return {};
    }
    return { height: this.height - 10 + 'px' };
  }
}
